require('./scheduleReportDialog.style.scss');

class ScheduleReportDialogController {
    constructor($scope, $filter, $element, $timeout, persistence, notificationService, utilsService, validationsService) {
        this.$scope = $scope;
        this.$filter = $filter;
        this.$element = $element;
        this.$timeout = $timeout;
        this.persistence = persistence;
        this.notificationService = notificationService;
        this.utilsService = utilsService;
        this.validationsService = validationsService;
        this.modalTitle = this.$filter('translate')('report.schedule.title');

        this.intervalOptions = [
            { id: 1, label: this.$filter('translate')('report.schedule.dialog.interval.option.daily.label'), value: 'DAILY' },
            { id: 2, label: this.$filter('translate')('report.schedule.dialog.interval.option.weekly.label'), value: 'WEEKLY' },
            { id: 3, label: this.$filter('translate')('report.schedule.dialog.interval.option.monthly.label'), value: 'MONTHLY' }
        ];

        this.typeOptions = [
            { id: 1, label: this.$filter('translate')('report.subscribe.dialog.type.option.pdf.label'), value: 'PDF' },
            { id: 2, label: this.$filter('translate')('report.subscribe.dialog.type.option.png.label'), value: 'PNG' },
            { id: 3, label: this.$filter('translate')('report.subscribe.dialog.type.option.csv.label'), value: 'CSV' }
        ];

        this.dateTimePickerOptions = this.utilsService.getDatePickerLocalOptions(true, { horizontal: 'right', vertical: 'bottom' });
        this.recipientsEmails = '';
    }

    $onInit() {
        this.closeId = { close: 'report-schedule-close', closeIcon: 'report-schedule-close-icon' };
        this.actionButtons = [
            { title: this.$filter('translate')('report.schedule.unschedule.button'), action: this.unscheduleReport.bind(this), isDisabled: () => this.busy || !this.report.scheduled, id: 'unschedule-reports' },
            { title: this.$filter('translate')('report.schedule.schedule.button'), action: this.scheduleReport.bind(this), isDisabled: () => (this.dialogForm && !this.dialogForm.$valid) || this.busy || (this.subscribe && this.emailsTagsActive), id: 'schedule-reports' },
        ];
    }

    onOpen() {
        this.renderCounter = 0;
        this.interval = this.intervalOptions[0];
        this.type = this.typeOptions[0];
        this.dateTimePickerOptions.defaultDate = this.$filter('localizeDate')(new Date(), 'short');
        this.emailsTagsActive = true;
        if (this.report.scheduled) {
            this.persistence.getScheduleReport(this.report).then(details => this.setReportScheduleDetails(details.data.entities[0]), err => { });
        }
        this.$element.on('keydown', (e) => {
            if (e.keyCode == 13) {
                e.preventDefault();
                e.stopPropagation();
                if (this.dialogForm && !this.dialogForm.$valid) return;
                this.$timeout(() => {
                    if (!this.showModal || this.renderCounter > 0) return;
                    this.renderCounter++;
                    this.scheduleReport();
                }, 0);
            }
        });
    }

    setReportScheduleDetails(reportScheduleDetails) {
        let cronDetails = reportScheduleDetails.cron;

        this.cronDate = moment.utc({
            y: cronDetails.year,
            M: cronDetails.month - 1,
            d: cronDetails.dayOfMonth,
            h: cronDetails.hour,
            m: cronDetails.minute
        }).toISOString();

        this.cronDate = this.$filter('localizeDate')(this.cronDate, 'short');

        let selectedInterval = this.intervalOptions.filter(u => u.value === cronDetails.interval.toUpperCase());

        this.interval = selectedInterval[0];

        if (reportScheduleDetails.enabled) {
            this.subscribe = reportScheduleDetails.enabled;
            let selectedType = this.typeOptions.filter(u => u.value === reportScheduleDetails.format.toUpperCase());
            this.type = selectedType[0];
            this.recipientsEmails = reportScheduleDetails.emailRecipients;
        }
    }

    onClose() {
        this.interval = this.intervalOptions[0];
        this.type = this.typeOptions[0];
        this.subscribe = false;
        this.recipientsEmails = '';
        this.emailsTagsActive = false;
        this.busy = false;
        this.showModal = false;
    }

    scheduleReport() {
        let tempFormat = this.dateTimePickerOptions && this.dateTimePickerOptions.format ? this.dateTimePickerOptions.format : 'l LT',
            momentDate = moment.utc(moment(this.cronDate, tempFormat).toDate().toISOString());
        const data = {
            cron: {
                year: momentDate.year(),
                month: momentDate.month() + 1,
                dayOfWeek: momentDate.day() === 0 ? 7 : momentDate.day(),
                dayOfMonth: momentDate.date(),
                hour: momentDate.hour(),
                minute: momentDate.minute(),
                interval: this.interval.value
            }
        };
        if (this.subscribe) {
            data.format = this.type.value;
            data.emailRecipients = this.recipientsEmails;
            data.scheduleLang = this.locale;
            data.userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        }
        data.enabled = this.subscribe;

        if (this.report.scheduled == false) {
            this.busy = this.persistence.createScheduleReport(this.report, data)
                .then(res => {
                    this.notificationService.pop(res.data.message);
                })
                .finally(() => {
                    this.onClose();
                    this.onClosed();
                });
        } else {
            this.busy = this.persistence.updateScheduleReport(this.report, data)
                .then(res => {
                    this.notificationService.pop(res.data.message);
                })
                .finally(() => {
                    this.onClose();
                    this.onClosed();
                });
        }
    }

    unscheduleReport() {
        const data = {
            ifScheduled: false
        };
        return this.busy = this.persistence.unscheduleReport(this.report, data).then(resp => {
            this.notificationService.pop(resp.data.message);
        })
            .finally(() => {
                this.onClose();
                this.onClosed();
            });
    }
}

ScheduleReportDialogController.$inject = ['$scope', '$filter', '$element', '$timeout', 'reportsPersistence', 'notificationService', 'utilsService', 'validationsService'];

const scheduleReportDialogComponent = {
    controller: ScheduleReportDialogController,
    template: require('./scheduleReportDialog.template.html'),
    bindings: {
        report: '<',
        showModal: '=',
        onClosed: '&'
    }
};

module.exports = scheduleReportDialogComponent;


// WEBPACK FOOTER //
// ./src/azurebackup/views/reports/dialogs/scheduleReportDialog/scheduleReportDialog.component.js